import Vue from 'vue';

Vue.filter('toFixed',  (price) =>  (+price).toFixed(2));

Vue.filter('noDecimal',  (price) =>  (+price).toFixed(0));

Vue.filter('toUSD', price => `$${price}`);

Vue.filter('cardNumbers', card_numbers => '**** '.repeat(1) + card_numbers.toString().slice(-4));

Vue.filter('ucfirst', str => str.charAt(0).toUpperCase() + str.slice(1));

Vue.filter('ucwords', str => str.toLowerCase().replace(/^[\u00C0-\u1FFF\u2C00-\uD7FF\w]|\s[\u00C0-\u1FFF\u2C00-\uD7FF\w]/g, letter => letter.toUpperCase()));
